/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { CommonDropdown, RegularButton, CommonInput, ICommonDropdownOption, Loader } from 'pg-ui-library';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import InvoiceService from 'src/services/invoice.service';
import { InvoiceListResponse } from 'src/interfaces/invoice';
import { useQuery } from '@tanstack/react-query';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { Container, ScreenHeader, RightHeader, PageTitle, EmptyContainer } from './createStyles';
import { CellSpan } from './styles';
import { InvoiceStatus } from './enums/invoice-status';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { NewFiltersInvoice } from './modals/filtersModal';
import DownloadInvoiceModal from './modals/DownloadInvoiceModal';
import BatchDownloadModal from './modals/batchDownloadModal';

const myinvocieOptions: ICommonDropdownOption[] = [
  // {
  //   key: '1',
  //   label: InvoiceStatus.ALL.label,
  //   value: InvoiceStatus.ALL.value,
  // },
  {
    key: '2',
    label: InvoiceStatus.DRAFT.label,
    value: InvoiceStatus.DRAFT.value,
  },
  {
    key: '3',
    label: InvoiceStatus.SUBMITTED.label,
    value: InvoiceStatus.SUBMITTED.value,
  },
  {
    key: '4',
    label: InvoiceStatus.APPROVED.label,
    value: InvoiceStatus.APPROVED.value,
  },
  {
    key: '5',
    label: InvoiceStatus.COMPLETED.label,
    value: InvoiceStatus.COMPLETED.value,
  },
  {
    key: '6',
    label: InvoiceStatus.REJECTED.label,
    value: InvoiceStatus.REJECTED.value,
  },
  {
    key: '7',
    label: InvoiceStatus.BILL_PROCESSED.label,
    value: InvoiceStatus.BILL_PROCESSED.value,
  },
  {
    key: '8',
    label: InvoiceStatus.PAY_PROCESSED.label,
    value: InvoiceStatus.PAY_PROCESSED.value,
  },
];

const InvoiceList: React.FC = () => {
  const navigate = useNavigate();
  const validationSchema = yup.object({
    subject: yup.string().max(255).required(),
  });

  const { t } = useTranslation();
  const statusMapping: Record<
    string,
    { color: 'default' | 'primary' | 'secondary' | 'error' | 'success'; label: string; bgColor: string }
  > = {
    rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Reject: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },

    draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },
    Draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },

    submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },
    Submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },

    approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    Approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    'On Hold': { color: 'default', label: 'Approved', bgColor: '#F9A825' },

    bill_processed: { color: 'default', label: 'Bill Processed', bgColor: '#7b1fa2' }, // purple
    Bill_processed: { color: 'default', label: 'Bill Processed', bgColor: '#7b1fa2' },

    pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' }, // teal
    Pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' },

    completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    resolved: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    Completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
  };

  const allStatusOptions: ICommonDropdownOption[] = Object.values(InvoiceStatus).map((status, index) => ({
    key: String(index),
    label: status.label,
    value: status.value,
  }));

  const viewInvoice = (row: any) => {
    navigate(`${row.id}`);
  };

  const invoiceColumns: GridColDef[] = [
    {
      headerName: 'ID',
      headerClassName: 'CommonHeaderClass',
      field: 'invoiceShowId',
      minWidth: 150,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents" onClick={() => viewInvoice(params.row)}>
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Worker',
      headerClassName: 'CommonHeaderClass',
      field: 'employeeName',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Start Date',
      headerClassName: 'CommonHeaderClass',
      field: 'periodStart',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'End Date',
      headerClassName: 'CommonHeaderClass',
      field: 'periodEnd',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Company',
      headerClassName: 'CommonHeaderClass',
      field: 'companyName',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Client',
      headerClassName: 'CommonHeaderClass',
      field: 'clientName',
      minWidth: 140,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Job Title',
      headerClassName: 'CommonHeaderClass',
      field: 'jobTitle',
      minWidth: 110,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Hire type',
      headerClassName: 'CommonHeaderClass',
      field: 'hireType',
      minWidth: 90,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Submitted Amount',
      headerClassName: 'CommonHeaderClass',
      field: 'submittedAmount',
      minWidth: 120,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const amount = params.value;
        const currency = params.row.currency;

        let symbol = '';
        switch (currency) {
          case 'USD':
            symbol = '$';
            break;
          case 'CAD':
            symbol = 'C$';
            break;
          case 'EUR':
            symbol = '€';
            break;
          default:
            symbol = '$';
        }

        return (
          <CellSpan title={`${symbol}${amount}`} data-tag="allowRowEvents">
            {symbol}
            {amount}
          </CellSpan>
        );
      },
    },
    {
      headerName: 'Version',
      headerClassName: 'CommonHeaderClass',
      field: 'version',
      minWidth: 90,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Status',
      field: 'status',
      width: 140,
      renderCell: params => {
        const status = params.value as string;
        const { label, bgColor } = statusMapping[status] || {
          color: 'default',
          label: 'Unknown',
          bgColor: '#9e9e9e',
        };
        return (
          <Chip
            label={label}
            variant="outlined"
            style={{
              backgroundColor: bgColor,
              fontSize: '12px',
              color: 'white',
              borderColor: 'transparent',
              textTransform: 'capitalize',
              borderRadius: '6px',
            }}
          />
        );
      },
    },
  ];

  const formik = useFormik({
    initialValues: {
      moduleCategory: '',
      subCatergory: '',
      subject: '',
      description: '',
      priority: '',
      attachments: '',
      searchQuery: '',
      invocieCategory: '',
    },
    validationSchema,
    onSubmit: async (values: any) => {
      try {
        console.log('Form Submitted:', values);
      } catch (error) {
        console.error('Error during form submission', error);
      }
    },
  });

  const CreateInvoice = () => {
    navigate('/invoices/create');
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setsearchTerm] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [status, setStatus] = useState('');
  const companyId = '';

  const [downloadOpen, setDownloadOpen] = useState(false);

  const [batchDownloadOpen, setBatchDownloadOpen] = useState(false);
  const [batchDownloadLoading, setBatchDownloadLoading] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const [newFilterIsOpen, setNewFilterIsOpen] = useState(false);

  const [filters, setFilters] = useState({
    startDate: null as Date | null,
    endDate: null as Date | null,
    status: '',
    hireType: '',
    showInvocieId: '',
    clientName: [] as string[],
    employeeName: '',
    companyName: '',
    dateCriteria: '',
    dateFilterType: '',
    assignmentId: '',
    accountingId: '',
  });

  const {
    isLoading,
    isFetching,
    data: invoiceData,
  } = useQuery<{
    items: InvoiceListResponse[];
    meta: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  }>(
    ['invoice-list', page, limit, searchTerm, sortBy, sortDirection, JSON.stringify(filters)],
    async () => {
      return InvoiceService.getInvoiceList({
        page,
        limit,
        search: searchTerm,
        sortBy,
        sortDirection,
        status: filters.status,
        hireType: filters.hireType,
        showInvocieId: filters.showInvocieId,
        assignmentId: filters.assignmentId,
        accountingId: filters.accountingId,
        clientName: filters.clientName,
        employeeName: filters.employeeName,
        dateCriteria: filters.dateCriteria,
        dateFilterType: filters.dateFilterType,
        startDate: apiStartDate,
        endDate: apiEndDate,
        ...(filters.companyName ? { companyName: filters.companyName } : {}),
      });
    },
    {
      keepPreviousData: true,
    }
  );

  const updateFilters = (
    startDate: Date | null,
    endDate: Date | null,
    selectedCompany: any,
    status: string,
    employmentType: string,
    showInvocieId: string,
    assignmentId: string,
    accountingId: string,
    employmentStatus: string,
    // clientName: string,
    clientName: string[],
    hireType: string,
    employeeName: string,
    dateCriteria: string,
    dateRangeType: string
  ) => {
    setPage(1);

    setFilters({
      startDate,
      endDate,
      status,
      hireType,
      showInvocieId,
      assignmentId,
      accountingId,
      clientName,
      employeeName,
      companyName: selectedCompany || '',
      dateCriteria: dateCriteria || 'period',
      dateFilterType: dateRangeType,
    });
  };

  const formatDateForApi = (date: Date | null) => {
    if (!date) return undefined;
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
  };

  const apiStartDate = formatDateForApi(filters.startDate);
  const apiEndDate = formatDateForApi(filters.endDate);

  useEffect(() => {}, [page, limit, searchTerm, status]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage);
  };

  const onPageMetaChange = (model: any) => {
    setPage(model.page + 1);
    setLimit(model.pageSize);
  };

  const onSortMetaChange = async (changes: any) => {
    setSortBy(changes[0].field as unknown as string);
    setSortDirection(changes[0].sort);
  };

  const formattedData = invoiceData?.items?.map(row => ({
    ...row,
  }));

  const handleDownload = async (type: 'excel' | 'csv' | 'pdf') => {
    setDownloadLoading(true);
    try {
      const url = InvoiceService.downloadInvoices({
        type,
        search: searchTerm,
        sortBy,
        sortDirection,
        status: filters.status,
        hireType: filters.hireType,
        showInvocieId: filters.showInvocieId,
        assignmentId: filters.assignmentId,
        accountingId: filters.accountingId,
        clientName: filters.clientName,
        employeeName: filters.employeeName,
        dateCriteria: filters.dateCriteria,
        dateFilterType: filters.dateFilterType,
        startDate: apiStartDate,
        endDate: apiEndDate,
        ...(filters.companyName ? { companyName: filters.companyName } : {}),
      });

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
        },
      });

      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();

      // Create a file name
      const fileExtension = type === 'pdf' ? 'zip' : type === 'csv' ? 'csv' : 'xlsx';
      const fileName = `Invoices_${new Date().toISOString().split('T')[0]}.${fileExtension}`;

      // Create a temporary link to trigger download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);

      setDownloadOpen(false);
    } catch (error) {
      console.error('Error downloading invoices:', error);
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleBatchDownload = async (batchCode: string) => {
    setBatchDownloadLoading(true);
    try {
      const url = InvoiceService.batchDownloadInvoices({
        batchCode,
      });

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
        },
      });

      if (!response.ok) throw new Error('Batch download failed');

      const blob = await response.blob();

      const fileName = `Batch_${batchCode}_${new Date().toISOString().split('T')[0]}.zip`;

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);

      setBatchDownloadOpen(false);
    } catch (error) {
      console.error('Error downloading batch invoices:', error);
    } finally {
      setBatchDownloadLoading(false);
    }
  };

  return (
    <Container>
      <NewFiltersInvoice
        isOpen={newFilterIsOpen}
        setIsOpen={setNewFilterIsOpen}
        updateFilters={updateFilters}
        statusOptions={allStatusOptions}
      />

      <DownloadInvoiceModal
        isOpen={downloadOpen}
        setIsOpen={setDownloadOpen}
        onDownload={handleDownload}
        loading={downloadLoading}
      />
      <BatchDownloadModal
        isOpen={batchDownloadOpen}
        setIsOpen={setBatchDownloadOpen}
        onBatchDownload={handleBatchDownload}
        loading={batchDownloadLoading}
      />

      {/* const [downloadbatch, setDownloadBatch] = useState(false); */}

      <ScreenHeader>
        <PageTitle>Invoices</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <RegularButton onClick={() => setNewFilterIsOpen(true)}>Filters</RegularButton>

          <RegularButton onClick={CreateInvoice}>Create Invoice</RegularButton>

          <RegularButton onClick={() => setDownloadOpen(true)}>Download Invoice</RegularButton>
          <RegularButton onClick={() => setBatchDownloadOpen(true)}>Download Batch</RegularButton>
        </RightHeader>
      </ScreenHeader>

      {isLoading || isFetching ? (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      ) : (
        <div>
          {formattedData && formattedData.length > 0 ? (
            <DataGrid
              rows={formattedData}
              columns={invoiceColumns}
              pagination
              paginationMode="server"
              onPaginationModelChange={state => {
                onPageMetaChange(state);
              }}
              onSortModelChange={state => {
                onSortMetaChange(state);
              }}
              paginationModel={{
                page: page - 1,
                pageSize: limit,
              }}
              pageSizeOptions={[10, 20, 50, 100]}
              rowCount={invoiceData?.meta?.total || 0}
              loading={isLoading || isFetching}
              disableColumnFilter
              sx={{
                font: '14px Biotif',
                fontWeight: 'bold',
                '& .CommonHeaderClass': {
                  color: '#9399B2',
                  font: '16px Biotif',
                  fontWeight: 'bold',
                },
                minHeight: '150px',
                '& .MuiDataGrid-scrollbar--horizontal': {
                  zIndex: 0,
                },
              }}
            />
          ) : (
            <div style={{ minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              No Invoices to display. If you need assistance, you can create a new Invoice by clicking &quot;Create
              Invoice.&quot;
            </div>
          )}
        </div>
      )}
    </Container>
  );
};

export default InvoiceList;
